import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function TermsConditions() {
  return (
    <div >
      <Helmet>
        <title>Terms & Conditions | BrightLife Physio Point</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

       <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                 Terms & Conditions
                </h1>
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Terms & Conditions</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div className="container my-5 legal-page">
      <h1>Terms & Conditions</h1>

      <p>
        By accessing this website or availing services from BrightLife Physio
        Point, you agree to the following terms and conditions.
      </p>

      <h3>Use of Website</h3>
      <p>
        The content on this website is for general information only and may be
        changed without notice.
      </p>

      <h3>Appointments</h3>
      <p>
        Appointment bookings are subject to availability. We reserve the right
        to reschedule or cancel appointments when necessary.
      </p>

      <h3>Limitation of Liability</h3>
      <p>
        BrightLife Physio Point shall not be liable for any indirect or
        consequential damages arising from use of this website or services.
      </p>

      <h3>Intellectual Property</h3>
      <p>
        All content, images, logos, and materials are the property of BrightLife
        Physio Point and may not be reused without permission.
      </p>

      <h3>Governing Law</h3>
      <p>
        These terms are governed by the laws of India. Any disputes shall be
        subject to the jurisdiction of Hyderabad courts.
      </p>
    </div>
    </div>
  );
}
